import { render, staticRenderFns } from "./ClaimSubmission.vue?vue&type=template&id=ce6e8948"
import script from "./ClaimSubmission.vue?vue&type=script&lang=js"
export * from "./ClaimSubmission.vue?vue&type=script&lang=js"
import style0 from "./ClaimSubmission.vue?vue&type=style&index=0&id=ce6e8948&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports